import AlertsApi from "../../../api/alerts-api";
import CowsApi from "../../../api/cows-api";

// initial state
const initialState = () => ({
  isFetching: false,
  lactation: {},
  health: {}
});

// actions
const actions = {
  getLactationChart: async ({ commit }) => {
    try {
      commit("request");
      const apiResponse = await CowsApi.lactation();

      if (apiResponse && apiResponse.data) {
        commit("getLactationChartSuccess", apiResponse.data);
      } else {
        commit("getChartFailed", apiResponse);
      }
    } catch (e) {
      commit("getChartFailed", e);
    }
  },

  getHealthChart: async ({ commit }) => {
    try {
      commit("request");
      const apiResponse = await AlertsApi.get({ totals_only: true, last_3_days: true });

      if (apiResponse && apiResponse.data) {
        commit("getHealthChartSuccess", apiResponse.data);
      } else {
        commit("getChartFailed", apiResponse);
      }
    } catch (e) {
      commit("getChartFailed", e);
    }
  },

  clearChart: ({ commit }) => {
    commit("clearChart", initialState());
  }
};

// mutations
const mutations = {
  request: state => {
    state.isFetching = true;
  },

  getLactationChartSuccess: (state, data) => {
    state.isFetching = false;
    state.lactation = data;
  },

  getHealthChartSuccess: (state, data) => {
    state.isFetching = false;
    state.health = data;
  },

  getChartFailed: state => {
    state.isFetching = false;
  },

  clearChart: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/chart.js